import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';

export default function Results() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState('all');

  const results = [
    {
      id: 1,
      exam: 'الرياضيات المتقدمة',
      date: '2024-02-01',
      score: 85,
      percentage: 85,
      status: 'ممتاز',
      icon: 'ri-calculator-line',
      color: 'bg-blue-500'
    },
    {
      id: 2,
      exam: 'الفيزياء العامة',
      date: '2024-01-28',
      score: 78,
      percentage: 78,
      status: 'جيد جداً',
      icon: 'ri-flask-line',
      color: 'bg-purple-500'
    },
    {
      id: 3,
      exam: 'اللغة الإنجليزية',
      date: '2024-01-25',
      score: 92,
      percentage: 92,
      status: 'ممتاز',
      icon: 'ri-english-input',
      color: 'bg-green-500'
    },
    {
      id: 4,
      exam: 'الكيمياء العضوية',
      date: '2024-01-22',
      score: 88,
      percentage: 88,
      status: 'ممتاز',
      icon: 'ri-test-tube-line',
      color: 'bg-orange-500'
    },
    {
      id: 5,
      exam: 'علوم الحاسب',
      date: '2024-01-20',
      score: 95,
      percentage: 95,
      status: 'ممتاز',
      icon: 'ri-code-line',
      color: 'bg-indigo-500'
    },
    {
      id: 6,
      exam: 'التاريخ الإسلامي',
      date: '2024-01-18',
      score: 72,
      percentage: 72,
      status: 'جيد',
      icon: 'ri-book-line',
      color: 'bg-amber-500'
    }
  ];

  const stats = {
    totalExams: results.length,
    averageScore: Math.round(results.reduce((acc, r) => acc + r.percentage, 0) / results.length),
    highestScore: Math.max(...results.map(r => r.percentage)),
    passedExams: results.filter(r => r.percentage >= 60).length
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-[#E8F5F3]">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-[#0F2A3A] mb-2">سجل النتائج</h1>
          <p className="text-slate-600 text-lg">تتبع تطور أدائك الأكاديمي</p>
        </div>

        {/* Stats Cards */}
        <div className="grid md:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl">
                <i className="ri-file-list-3-line text-2xl text-blue-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">{stats.totalExams}</span>
            </div>
            <p className="text-slate-600 font-semibold">إجمالي الاختبارات</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-xl">
                <i className="ri-percent-line text-2xl text-green-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">{stats.averageScore}%</span>
            </div>
            <p className="text-slate-600 font-semibold">المتوسط العام</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-xl">
                <i className="ri-trophy-line text-2xl text-purple-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">{stats.highestScore}%</span>
            </div>
            <p className="text-slate-600 font-semibold">أعلى درجة</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-lg">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl">
                <i className="ri-checkbox-circle-line text-2xl text-orange-600"></i>
              </div>
              <span className="text-3xl font-bold text-[#0F2A3A]">{stats.passedExams}</span>
            </div>
            <p className="text-slate-600 font-semibold">اختبارات ناجحة</p>
          </div>
        </div>

        {/* Performance Chart */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-[#0F2A3A] mb-6">تطور الأداء</h2>
          <div className="h-64 flex items-end justify-between gap-4">
            {results.map((result, index) => (
              <div key={index} className="flex-1 flex flex-col items-center">
                <div className="w-full bg-slate-100 rounded-t-lg overflow-hidden relative" style={{ height: '200px' }}>
                  <div
                    className={`absolute bottom-0 w-full ${
                      result.percentage >= 85 ? 'bg-green-500' :
                      result.percentage >= 70 ? 'bg-blue-500' :
                      result.percentage >= 60 ? 'bg-yellow-500' : 'bg-red-500'
                    } transition-all duration-500 rounded-t-lg flex items-start justify-center pt-2`}
                    style={{ height: `${result.percentage}%` }}
                  >
                    <span className="text-white font-bold text-sm">{result.percentage}%</span>
                  </div>
                </div>
                <p className="text-xs text-slate-600 mt-2 text-center">{result.date}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Filter Tabs */}
        <div className="bg-white rounded-xl shadow-lg p-2 mb-6 inline-flex gap-2">
          <button
            onClick={() => setFilter('all')}
            className={`px-6 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              filter === 'all' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            الكل
          </button>
          <button
            onClick={() => setFilter('excellent')}
            className={`px-6 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              filter === 'excellent' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            ممتاز
          </button>
          <button
            onClick={() => setFilter('good')}
            className={`px-6 py-2 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
              filter === 'good' ? 'bg-[#1ABC9C] text-white' : 'text-slate-600 hover:bg-slate-100'
            }`}
          >
            جيد
          </button>
        </div>

        {/* Results List */}
        <div className="grid md:grid-cols-2 gap-6">
          {results.map((result) => (
            <div key={result.id} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all overflow-hidden">
              <div className={`${result.color} p-6 text-white`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl">
                      <i className={`${result.icon} text-3xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-1">{result.exam}</h3>
                      <p className="text-white/80 text-sm">{result.date}</p>
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="text-4xl font-bold mb-1">{result.percentage}%</div>
                    <span className="text-sm text-white/80">{result.status}</span>
                  </div>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-slate-600">الدرجة</span>
                  <span className="text-2xl font-bold text-[#0F2A3A]">{result.score}/100</span>
                </div>

                <div className="w-full h-2 bg-slate-200 rounded-full overflow-hidden mb-4">
                  <div
                    className={`h-full ${
                      result.percentage >= 85 ? 'bg-green-500' :
                      result.percentage >= 70 ? 'bg-blue-500' :
                      result.percentage >= 60 ? 'bg-yellow-500' : 'bg-red-500'
                    }`}
                    style={{ width: `${result.percentage}%` }}
                  ></div>
                </div>

                <div className="flex gap-3">
                  <button
                    onClick={() => navigate(`/exam-result/${result.id}`)}
                    className="flex-1 py-3 bg-[#1ABC9C] text-white font-semibold rounded-xl hover:bg-[#16a085] transition-all whitespace-nowrap cursor-pointer"
                  >
                    عرض التفاصيل
                  </button>
                  <button className="px-4 py-3 bg-slate-100 text-slate-700 font-semibold rounded-xl hover:bg-slate-200 transition-all whitespace-nowrap cursor-pointer">
                    <i className="ri-download-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
